/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { smallerDependencies } from './dependenciesSmaller.generated';
import { createImmutableDenseMatrixClass } from '../../factoriesAny.js';
export var ImmutableDenseMatrixDependencies = {
  DenseMatrixDependencies: DenseMatrixDependencies,
  smallerDependencies: smallerDependencies,
  createImmutableDenseMatrixClass: createImmutableDenseMatrixClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesImmutableDenseMatrixClass.generated.js
// module id = 634
// module chunks = 0